<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="edit">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <h4 class="modal-title">{{form.modal.title}}</h4>
        </div>
        <div class="modal-body">

          <div class="panel-body" v-if="form.data.barrier">
            <div class="row panel-heading">
              <div class="col-sm-12 text-center">
                <form class="form-inline search-fields" @submit.prevent="form.onSiteSearch('siteId')">
                  <div class="form-group">
                    <select class="form-control" id="searchField" name="searchField" v-model="form.siteSearch.field">
                      <option value="site">Site</option>
                      <option value="zone">Zone</option>
                      <option value="address">Address</option>
                    </select>
                  </div>
                  <div class="input-group">
                    <input type="search" placeholder="search sites" class="form-control" v-model="form.siteSearch.term">
                    <span class="input-group-addon pointer" v-on:click="form.onSiteSearch('siteId')" title="search"><i class="fa fa-search"></i></span>
                  </div>
                  <i class="fa fa-spinner fa-spin" v-if="siteSearch.loading"></i>
                  <button type="button" class="btn btn-default ml-20" v-if="!siteSearch.loading" v-on:click="newSite">Create new site</button>
                </form>
              </div>
            </div>
          </div>

          <form @submit.prevent="form.onSubmit" @keydown="form.errors.clear($event.target.id)">
            <input type="hidden" name="id" v-model="form.data.id">

            <div v-if="form.csv">
              Please pick the spray data you wish to use:
              <table class="table table-striped">
                <thead>
                  <th width="40"></th>
                  <th>Contract</th>
                  <th>Truck</th>
                  <th>Applicator</th>
                  <th>Zone</th>
                </thead>
                <tbody>
                  <tr v-for="record in form.csv" v-on:click="csvFill(record.Contract)" class="pointer">
                    <td><input type="radio" name="csvChosen" v-model="csvChosen" v-bind:value="record.Contract"></td>
                    <td>{{ record.Contract }}</td>
                    <td>{{ record.Truck }}</td>
                    <td>{{ record.Applicator }}</td>
                    <td>{{ record.TreatmentArea }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-if="form.data.barrier">
              <div class="form-group" :class="{'has-error': form.errors.has('siteId') }">
                <label class="control-label">Site</label>
                <div class="form-group">
                  <select class="form-control" v-model="form.data.siteId" v-on:change="setSelected">
                    <option v-for="item in siteSearch.sites" v-bind:value="item.id">{{item.attributes.name}}</option>
                  </select>
                </div>
                <span class="help-block" v-if="form.errors.has('siteId')" v-text="form.errors.get('siteId')"></span>
              </div>

              <div class="site-details">
                <div class="row">
                  <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Name:</strong> {{ siteSearch.selected.name }}</div>
                  <div class="col-xs-12 col-sm-4"><strong>Address:</strong> {{ siteSearch.selected.address }}, {{ siteSearch.selected.city }}, {{ stateName(siteSearch.selected.stateId) }} {{ siteSearch.selected.zip }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-4 col-sm-offset-2"><strong>Zone:</strong> {{ zoneName(siteSearch.selected.zoneId) }}</div>
                  <div class="col-xs-12 col-sm-4"><strong>Route:</strong> {{ routeName(siteSearch.selected.routeId) }}</div>
                </div>
              </div>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('contractId') }" v-if="form.data.truck">
              <label class="control-label">Contract</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.contractId">
                  <option></option>
                  <option v-for="item in contracts" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('contractId')" v-text="form.errors.get('contractId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('countyId') }">
              <label class="control-label">County <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.countyId">
                  <option></option>
                  <option v-for="item in counties" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('countyId')" v-text="form.errors.get('countyId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('applicationDate') }">
              <label class="control-label">Application Date</label>
              <date-picker v-model="form.data.applicationDate"></date-picker>
              <span class="help-block" v-if="form.errors.has('applicationDate')" v-text="form.errors.get('applicationDate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('zoneId') }" v-if="form.data.truck">
              <label class="control-label">Zone or Treatment Area <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.zoneId">
                  <option></option>
                  <option v-for="item in zones" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('zoneId')" v-text="form.errors.get('zoneId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('municipalityId') }" v-if="form.data.truck">
              <label class="control-label">Municipality <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.municipalityId">
                  <option></option>
                  <option v-for="item in municipalities" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('municipalityId')" v-text="form.errors.get('municipalityId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('aequipId') }">
              <label class="control-label">Equipment Used<span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.aequipId">
                  <option></option>
                  <option v-for="item in equipment" v-bind:value="item.id">{{item.attributes.appType}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('aequipId')" v-text="form.errors.get('aequipId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('truckId') }">
              <label class="control-label">Truck<span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.truckId">
                  <option></option>
                  <option v-for="item in trucks" v-bind:value="item.id">{{item.attributes.name}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('truckId')" v-text="form.errors.get('truckId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('applicatorId') }">
              <label class="control-label">Applicator</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.applicatorId">
                  <option></option>
                  <option v-for="item in applicators" v-bind:value="item.id">{{item.attributes.inspector}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('applicatorId')" v-text="form.errors.get('applicatorId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('achemicalId') }">
              <label class="control-label">Chemical</label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.achemicalId">
                  <option></option>
                  <option v-for="item in achemicals" v-bind:value="item.id">{{item.attributes.chemName}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('achemicalId')" v-text="form.errors.get('achemicalId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('mixRatioId') }">
              <label class="control-label">Mix Ratio <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.mixRatioId">
                  <option></option>
                  <option v-for="item in mixRatios" v-bind:value="item.id">{{item.attributes.ratio}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('mixRatioId')" v-text="form.errors.get('mixRatioId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('adultapprateId') }">
              <label class="control-label">Appl. Rate <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.adultapprateId">
                  <option></option>
                  <option v-for="item in adultAppRates" v-bind:value="item.id">{{item.attributes.apprate}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('adultapprateId')" v-text="form.errors.get('adultapprateId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('flowRate') }">
              <label class="control-label">Flow Rate <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="flowRate" v-model="form.data.flowRate">
              <span class="help-block" v-if="form.errors.has('flowRate')" v-text="form.errors.get('flowRate')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('temperature') }">
              <label class="control-label">Temperature <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="temperature" v-model="form.data.temperature">
              <span class="help-block" v-if="form.errors.has('temperature')" v-text="form.errors.get('temperature')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('windSpeed') }">
              <label class="control-label">Wind Speed <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="windSpeed" v-model="form.data.windSpeed">
              <span class="help-block" v-if="form.errors.has('windSpeed')" v-text="form.errors.get('windSpeed')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('windDirectionId') }">
              <label class="control-label">Wind Direction <span class="optional">(optional)</span></label>
              <div class="form-group">
                <select class="form-control" v-model="form.data.windDirectionId">
                  <option></option>
                  <option v-for="item in windDirections" v-bind:value="item.id">{{item.attributes.direction}}</option>
                </select>
              </div>
              <span class="help-block" v-if="form.errors.has('windDirectionId')" v-text="form.errors.get('windDirectionId')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('startTime') }">
              <label class="control-label">Start Time <span class="optional">(optional)</span></label>
              <masked-input v-model="form.data.startTime" mask="11:11" placeholder="HH:MM" class="form-control" />
              <span class="help-block" v-if="form.errors.has('startTime')" v-text="form.errors.get('startTime')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('endTime') }">
              <label class="control-label">End Time <span class="optional">(optional)</span></label>
              <masked-input v-model="form.data.endTime" mask="11:11" placeholder="HH:MM" class="form-control" />
              <span class="help-block" v-if="form.errors.has('endTime')" v-text="form.errors.get('endTime')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('odometerStart') }">
              <label class="control-label">Odometer Start <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="odometerStart" v-model="form.data.odometerStart">
              <span class="help-block" v-if="form.errors.has('odometerStart')" v-text="form.errors.get('odometerStart')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('odometerEnd') }">
              <label class="control-label">Odometer End <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="odometerEnd" v-model="form.data.odometerEnd">
              <span class="help-block" v-if="form.errors.has('odometerEnd')" v-text="form.errors.get('odometerEnd')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('sprayerStart') }">
              <label class="control-label">Sprayer Start <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="sprayerStart" v-model="form.data.sprayerStart">
              <span class="help-block" v-if="form.errors.has('sprayerStart')" v-text="form.errors.get('sprayerStart')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('sprayerEnd') }">
              <label class="control-label">Sprayer End <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="sprayerEnd" v-model="form.data.sprayerEnd">
              <span class="help-block" v-if="form.errors.has('sprayerEnd')" v-text="form.errors.get('sprayerEnd')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('tripMiles') }">
              <label class="control-label">Trip Miles <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="tripMiles" v-model="form.data.tripMiles">
              <span class="help-block" v-if="form.errors.has('tripMiles')" v-text="form.errors.get('tripMiles')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('sprayMiles') }">
              <label class="control-label">Spray Miles <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="sprayMiles" v-model="form.data.sprayMiles">
              <span class="help-block" v-if="form.errors.has('sprayMiles')" v-text="form.errors.get('sprayMiles')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('sprayAcres') }">
              <label class="control-label">Spray Acres <span class="optional">(optional)</span></label>
              <input type="text" class="form-control" id="sprayAcres" v-model="form.data.sprayAcres">
              <span class="help-block" v-if="form.errors.has('sprayAcres')" v-text="form.errors.get('sprayAcres')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('ouncesSprayed') }">
              <label class="control-label">Ounces Sprayed</label>
              <input type="text" class="form-control" id="ouncesSprayed" v-model="form.data.ouncesSprayed">
              <span class="help-block" v-if="form.errors.has('ouncesSprayed')" v-text="form.errors.get('ouncesSprayed')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('vizualMonitorPerformed') }">
              <label>
                <input type="checkbox" id="vizualMonitorPerformed" v-model="form.data.vizualMonitorPerformed"> Visual Monitoring</label>
              <span class="help-block" v-if="form.errors.has('vizualMonitorPerformed')" v-text="form.errors.get('vizualMonitorPerformed')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('adverseIncident') }">
              <label>
                <input type="checkbox" id="adverseIncident" v-model="form.data.adverseIncident"> Adverse Incident
               <span class="optional">(optional)</span></label>
              <span class="help-block" v-if="form.errors.has('adverseIncident')" v-text="form.errors.get('adverseIncident')"></span>
            </div>

            <div class="checkbox" :class="{'has-error': form.errors.has('waterOfUs') }">
              <label>
                <input type="checkbox" id="waterOfUs" v-model="form.data.waterOfUs"> Water Of US
               <span class="optional">(optional)</span></label>
              <span class="help-block" v-if="form.errors.has('waterOfUs')" v-text="form.errors.get('waterOfUs')"></span>
            </div>

            <div class="form-group" :class="{'has-error': form.errors.has('workStatus') }">
              <label class="control-label">Work Status</label>
              <select class="form-control" v-model="form.data.workStatus">
                <option v-for="item in workStatus">{{item}}</option>
              </select>
              <span class="help-block" v-if="form.errors.has('workStatus')" v-text="form.errors.get('workStatus')"></span>
            </div>

            <loading-button :loading="form.loading" class="btn btn-primary" :disabled="form.errors.any()">Save</loading-button>
            <button type="button" class="btn btn-default" data-dismiss="modal">cancel</button>
          </form>
        </div>
        <div class="modal-footer">
        </div>
      </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
  </div><!-- /.modal -->
</template>

<script>
  import LoadingButton from '@/components/loading-button';
  import MaskedInput from 'vue-masked-input';
  import _ from 'lodash';
  import DatePicker from '@/components/date-picker';

  export default {
    name: 'adulticide-form',

    props: ['form'],

    components: {
      LoadingButton,
      MaskedInput,
      DatePicker,
    },

    data() {
      return {
        siteSearch: this.$store.getters.siteSearch,
        csvChosen: null,
      }
    },

    methods: {
      csvFill(contract) {
        let record = _.find(this.form.csv, ['Contract', contract]);
        this.csvChosen = record.Contract;

        this.form.data.startTime = record['Date'].split(' ')[1];
        this.form.data.applicatorId = this.$store.getters.applicatorIdByName(record['Applicator']);
        this.form.data.achemicalId = this.$store.getters.achemicalIdByName(record['Chemical']);
        this.form.data.mixRatioId = this.$store.getters.mixRatioIdByName(record['Mix_Ratio']);
        this.form.data.flowRate = record['Flow_Rate'];
        this.form.data.adultapprateId = this.$store.getters.adultAppRatesIdByName(record['App_Rate']);
//        this.form.data.municipalityId = this.$store.getters.municipalityIdByName(record['Muni']);
//        this.form.data.zoneId = this.$store.getters.zoneIdByName(record['TreatmentArea']);
        this.form.data.temperature = record['Temperature'];
        this.form.data.windSpeed = record['Wind_Speed'];
        this.form.data.windDirectionId = this.$store.getters.windDirectionIdByName(record['Wind_Direction']);
        this.form.data.vizualMonitorPerformed = this.stringToBool(record['Visual']);
        this.form.data.adverseIncident = this.stringToBool(record['Adverse']);
        this.form.data.waterOfUs = this.stringToBool(record['WoUS']);
        this.form.data.vizualMonitorId = this.$store.getters.vizualMonitorIdByName(record['VizMonReason']);
        this.form.data.tripMiles = record['Total Miles'];
        this.form.data.sprayMiles = record['Spray Miles'];
        this.form.data.ouncesSprayed = record['OZ Sprayed'];
        this.form.data.sprayAcres = record['Acres'];

      },
      stringToBool(string) {
        return string == '0' ? false : true;
      },
      zoneName(id) {
        return this.$store.getters.zoneNameById(id);
      },
      routeName(id) {
        return this.$store.getters.routeNameById(id);
      },
      stateName(id) {
        return this.$store.getters.stateNameById(id);
      },
      setSelected() {
        this.$store.dispatch('setSiteSearchSelected', this.form.data.siteId);
      },
      newSite() {
        this.form.hideEdit();
        this.$router.push({name: 'data-sites-new'})
      }
    },

    computed: {
      sites() {
        return this.$store.getters.sites;
      },
      contracts() {
        return this.$store.getters.contracts;
      },
      counties() {
        return this.$store.getters.counties;
      },
      municipalities() {
        return this.$store.getters.municipalities;
      },
      achemicals() {
        return this.$store.getters.achemicals;
      },
      mixRatios() {
        return this.$store.getters.mixRatios;
      },
      windDirections() {
        return this.$store.getters.windDirections;
      },
      applicators() {
        return this.$store.getters.applicators;
      },
      equipment() {
        return this.$store.getters.aEquipment;
      },
      vizualMonitors() {
        return this.$store.getters.vizualMonitors;
      },
      adultAppRates() {
        return this.$store.getters.adultAppRates;
      },
      workStatus() {
        return this.$store.getters.workStatus;
      },
      zones() {
        return this.$store.getters.zones;
      },
      trucks() {
        return this.$store.getters.trucks;
      },
    },

  }

</script>